<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="contact-page grey-bg">
  <div class="career-banner">
    <img src="assets/images/contact.jpg" alt="contact banner" />
  </div>
  <h1 class="text-center">Contact us </h1>
  <p class="contact-subtitle text-center">Questions about the programs, products or services offered on our site? We’re
    here to help!</p>
  <section class="fearless-explorers">
    <div class="container">
      <div class="details-contact d-flex justify-content-between flex-wrap">
        <div class="address">
          <h2>Email</h2>
          <p> You can reach us directly by emailing
          </p>
          <a href="mailto:info@mylifewell.com"> info@mylifewell.com. </a>
        </div>
        <div class="social-wrap">
          <h2> We're social. Join us!</h2>
          <ul class="social-links d-flex justify-content-between align-items-center">
            <li>
              <a target="_blank" href="https://www.facebook.com/mylifewell1"> <i class="icon-fb">&nbsp;</i> </a>
            </li>
            <li>
              <a target="_blank" href="https://twitter.com/mylifewell_"> <i class="icon-twit">&nbsp;</i> </a>
            </li>
            <li>
              <a target="_blank" href="https://www.instagram.com/mylifewell_/"> <i class="icon-ins">&nbsp;</i> </a>
            </li>
            <li>
              <a class="social-youtube"
                href="https://www.youtube.com/channel/UCCFC7tdfd3MGjNE4BhMhbRQ?view_as=subscriber" target="_blank"><img
                  src="assets/images/youtube.svg" alt="youtube"></a>
            </li>
            <li>
              <a class="social-pintrest" href="https://www.pinterest.com/MyLifeWell/" target="_blank"><img
                  src="assets/images/pintrest.svg" alt="pintrest"></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="contactform-wrapper d-md-flex justify-content-md-center">
        <div class="application-form">
          <div class="form-wrap static-form">
            <div id="sign-up-form">
              <h2 class="text-center general-title"> For General Enquiries & Further Information, </h2>
              <form [formGroup]="form">
                <div class="inp-wrap d-flex justify-content-between flex-wrap">
                  <div class="inp-fld">
                    <label>First Name*</label>
                    <input formControlName="firstName" id="firstName" type="text" class="form-control"
                      placeholder="john" [ngClass]="{ 'is-invalid': submitted && f['firstName'].errors }" />
                    <div *ngIf="submitted && f['firstName'].errors" class="invalid-feedback">
                      <div *ngIf="f['firstName'].errors['required']">First Name is required</div>
                      <div *ngIf="f['firstName'].errors['minlength']">First Name must be at least 3 characters</div>
                    </div>
                  </div>
                  <div class="inp-fld">
                    <label>Last Name*</label>
                    <input formControlName="lastName" id="lastName" type="text" class="form-control" placeholder="doe"
                      [ngClass]="{ 'is-invalid': submitted && f['lastName'].errors }" />
                    <div *ngIf="submitted && f['lastName'].errors" class="invalid-feedback">
                      <div *ngIf="f['lastName'].errors['required']">Last Name is required</div>
                      <div *ngIf="f['lastName'].errors['minlength']">Last Name must be at least 3 characters</div>
                    </div>
                  </div>
                </div>
                <div class="inp-wrap d-flex justify-content-between flex-wrap">
                  <div class="inp-fld">
                    <label>Email Address*</label>
                    <input formControlName="email" id="email" type="text" class="form-control" placeholder="email"
                      [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
                    <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
                      <div *ngIf="f['email'].errors['required']">Email is required</div>
                      <div *ngIf="f['email'].errors['email']">Email is invalid</div>
                    </div>
                  </div>
                  <div class="inp-fld">
                    <label>Mobile No</label>
                    <input formControlName="mobile" id="mobile" type="text" class="form-control"
                      placeholder="9027xxxx80" [ngClass]="{ 'is-invalid': submitted && f['mobile'].errors }" />
                    <div *ngIf="submitted && f['mobile'].errors" class="invalid-feedback">
                      <div *ngIf="f['mobile'].errors['required']">mobile is required</div>
                      <div *ngIf="f['mobile'].errors['minlength']">
                        Mobile must be at least 10 digit.
                      </div>
                      <div *ngIf="f['mobile'].errors['maxlength']">
                        Mobile must be at most 10 digit.
                      </div>
                    </div>
                  </div>

                </div>
                <div class="text-fld">
                  <label>Comments</label>
                  <textarea formControlName="comments" id="comments" type="text" class="form-control"
                    placeholder="write comment here ..."> </textarea>
                </div>
                <div class="submit-btn  text-center">
                  <button class="btn" (click)="submitForm()">Submit </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>